import { render, staticRenderFns } from "./Rxqx.vue?vue&type=template&id=1067e885"
import script from "./Rxqx.vue?vue&type=script&lang=js"
export * from "./Rxqx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports